/**
 * LocationPanel — edits contact + location metadata (builder metadata only, never the
 * rendered contact section). Seeded from the generated schema's contact content where
 * available; see BuilderEditorContext.withBusinessInfo.
 */
import { useBuilderEditor } from './editorContext'
import type { BusinessTextField } from './editorContext'
import { Fieldset, TextField } from './controls'

const FIELDS: { key: BusinessTextField; label: string; placeholder?: string }[] = [
  { key: 'email', label: 'Email', placeholder: 'hello@business.com' },
  { key: 'phone', label: 'Phone', placeholder: '+1 555 123 4567' },
  { key: 'street', label: 'Street', placeholder: '123 Main St' },
  { key: 'unit', label: 'Unit / Suite', placeholder: 'Suite 200' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State / Region' },
  { key: 'zip', label: 'ZIP / Postal code' },
]

export function LocationPanel() {
  const e = useBuilderEditor()
  const info = e.schema.businessInfo ?? {}
  return (
    <div>
      <Fieldset title="Location details">
        {FIELDS.map((f) => (
          <TextField
            key={f.key}
            label={f.label}
            value={info[f.key] ?? ''}
            placeholder={f.placeholder}
            onChange={(v) => e.setBusinessField(f.key, v)}
          />
        ))}
      </Fieldset>
    </div>
  )
}
